import { Link } from "react-router-dom";

const Cancel = () => {
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h2>🚫 Payment Canceled</h2>
      <p>Your subscription was not completed. If this was a mistake, you can try again.</p>
      <Link to="/checkout" style={{ textDecoration: "none", color: "#007bff", fontSize: "18px" }}>
        Try Again
      </Link>
    </div>
  );
};

export default Cancel;
